module.exports = __webpack_public_path__ + "static/img/ic_level_s.4f30b277.svg";